import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

const TutorProfilePagePlaceholder: React.FC = () => (
  <LoadingBox width="100%" height="800px" borderRadius="16px" />
)

export default TutorProfilePagePlaceholder
